import { Component } from "react";
import { Navigate } from "react-router-dom";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";

import { useNavigate, NavLink } from "react-router-dom";
import AuthService from "../services/auth.service";
import authService from "../services/auth.service";
import { getSubdomain } from "../services/getSubdomain";

type Props = {};

type State = {
  redirect: string | null,
  reload: boolean | null,
  email: string,
  password: string,
  firstName: string,
  lastName: string,
  loading: boolean,
  message: string,
  preMessage: string,
  subdomain: any | null,
};

export default class Register extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.handleLogin = this.handleLogin.bind(this);
    this.state = {
      redirect: null,
      reload: null,
      email: "",
      password: "",
      firstName: "",
      lastName: "",
      loading: false,
      message: "",
      preMessage: "",
      subdomain : getSubdomain(),
    };
  }

  async componentDidMount() {

    const currentUser = await AuthService.getCurrentUser();
    if (currentUser) {
      this.setState({ redirect: "/" });
    }
    const queryParameters = new URLSearchParams(window.location.search)
    const email = queryParameters.get("email")
    const token = queryParameters.get("token")

    this.setState({ email: email });
    await authService.getInvitation(email, token).then(
      response => {
      },
      error => {

    this.setState({ preMessage: "Hi, looks like we could not find your email or invitation. Please get in touch with your innovation manager!" });
      })
    

  }

  componentWillUnmount() {
    //window.location.reload();
  }

  validationSchema() {
    return Yup.object().shape({
      firstName: Yup.string().required("This field is required!"),
      lastName: Yup.string().required("This field is required!"),
      password: Yup.string().required("This field is required!").min(8, 'Your password is too short.'),
      password_repeat: Yup.string().oneOf([Yup.ref('password'), null], 'Passwords must match'),
    });
  }

  async handleLogin(formValue: { password_repeat: string; password: string, firstName: string, lastName: string, companyName: string }) {
    const { password, password_repeat, firstName, lastName, companyName  } = formValue;

    this.setState({
      message: "",
      loading: true
    });

    await AuthService.register(this.state.email, password, firstName, lastName, companyName).then(
      () => {
        this.setState({
          redirect: "/",
          reload: true
        });
      },
      error => {
        const resMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();

        this.setState({
          loading: false,
          message: resMessage
        });
      }
    );

  }

  render() {
    if (this.state.reload) {
      window.location.reload();
    }
    if (this.state.redirect) {
      return <Navigate to={this.state.redirect} />
    }

    const { loading, message } = this.state;

    const initialValues = {
      password: "",
      password_repeat: "",
      firstName: "",
      lastName: "",
      companyName: "",
    };

    return (
      <div className="container">
        <div className="row mt-4"  >
          <div className="col-md-6 text-center">
            <div style={{ display: "inline-block" }}> <img src={process.env.PUBLIC_URL + '/img/Innophant_Logo_large.svg'} /></div>
          </div>
          <div className="col-md-6  text-center">
            Already have an account?
            <NavLink to="/login" className="btn btn-light ms-3"> Login </NavLink>
                    
          </div>
        </div>
        <div className="row " style={{ marginTop: '3rem'}}  >
          <div className="col-lg-6 text-center d-none d-lg-block">
            <div style={{ fontSize: '67px'}} >
              <img style={{width: '60%'}} src={process.env.PUBLIC_URL + '/img/Innophant_Logo_large.svg'} />
              
            </div>

            <div style={{ fontSize: '28px'}} >
              Connecting talent to boost business innovation.
            </div>

            <div style={{ marginTop: '3rem'}} >
              <img src={process.env.PUBLIC_URL + '/img/login.svg'} />
              
            </div>
          </div>
          <div className="col-lg-6  text-left ps-lg-5 pe-lg-5">
            <div className="mt-5 mb-5" style={{ fontSize: '28px'}}>
              <strong>Join Innophant</strong> 
            </div>
            <div className="mt-5 mb-5">
              &nbsp;
            </div>
            <div className="mt-5 mb-5">
            {this.state.preMessage.length > 0 ? (
              <div className="alert alert-info">{this.state.preMessage}</div>
            )
            :
            (
              <Formik
              initialValues={initialValues}
              validationSchema={() => this.validationSchema()}
              onSubmit={this.handleLogin}
            >
              <Form>
                {['eca', 'sap-alumni'].includes(this.state.subdomain) ? (
                <div className="form-group">
                  <label htmlFor="firstName">Company Name</label>
                  <Field name="companyName" type="text" className="form-control"/>
                  <ErrorMessage
                    name="companyName"
                    component="div"
                    className="alert alert-danger"
                  />
                </div>
                ): ''}

                <div className="form-group mt-3">
                  {['eca', 'sap-alumni'].includes(this.state.subdomain) ? (
                    <><label htmlFor="firstName" className="w100 fw-bold">Primary Contact</label>
                    <br></br></>):''}
                  <label htmlFor="firstName">First Name</label>
                  <Field name="firstName" type="text" className="form-control"/>
                  <ErrorMessage
                    name="firstName"
                    component="div"
                    className="alert alert-danger"
                  />
                </div>
                <div className="form-group mt-3">
                  <label htmlFor="lastName">Last Name</label>
                  <Field name="lastName" type="text" className="form-control"/>
                  <ErrorMessage
                    name="lastName"
                    component="div"
                    className="alert alert-danger"
                  />
                </div>

                <div className="form-group mt-3">
                  <label htmlFor="password">Password</label>
                  <Field name="password" type="password" className="form-control" />
                  <ErrorMessage
                    name="password"
                    component="div"
                    className="alert alert-danger"
                  />
                </div>

                <div className="form-group mt-3">
                  <label htmlFor="password_repeat">Repeat Password</label>
                  <Field name="password_repeat" type="password" className="form-control" />
                  <ErrorMessage
                    name="password_repeat"
                    component="div"
                    className="alert alert-danger"
                  />
                </div>

                <div className="form-group mt-5">
                <div className="form-check">
                  <label className="form-check-label" >
                  I agree to the 
                  {this.state.subdomain == 'eca' ? 
                    <NavLink to="https://european-champions.org/legal-terms-privacy-policy" target="_blank" className="btn btn-light ms-3"> Privacy Policy </NavLink>
                    : 
                    <NavLink to="https://innophant.com/privacy" target="_blank" className="btn btn-light ms-3"> Privacy Policy </NavLink>
                  }
                   
                  and 
                  

                  {this.state.subdomain == 'eca' ? 
                    <NavLink to="https://european-champions.org/legal-terms-privacy-policy" target="_blank" className="btn btn-light ms-3"> Terms of Service </NavLink>
                    : 
                    <NavLink to="https://innophant.com/terms" target="_blank" className="btn btn-light ms-3"> Terms of Service </NavLink>
                  }
                  .
                    <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault" required></input>
                  
                  </label>
                </div>

                </div>
                <div className="form-group d-grid gap-2">
                <button type="submit" className="btn btn-primary btn-block" disabled={loading}>
                    {loading && (
                      <span className="spinner-border spinner-border-sm"></span>
                    )}
                    <span>Register Account</span>
                  </button>
                  <button type="button" className="btn btn-light mt-3" >
                    <span>Login via Single-Sign-on (SSO)</span>
                  </button>
                </div>

                {message && (
                  <div className="form-group mt-3">
                    <div className="alert alert-danger" role="alert">
                      {message}
                    </div>
                  </div>
                )}
              </Form>
            </Formik> 
            )
            }
            
            </div>
            
          </div>
        </div>
      </div>
    );
  }
}
